import ComponentName from '../constant/ComponentName';
import { DefaultFilter } from '../domain/rbac/RbacDomains';
import { ActiveRiskType } from '../domain/stream/transaction/TransactionDomains';

export interface DefaultFilterKey {
  component: ComponentName;
  riskType: ActiveRiskType;
  id?: string;
}

class DefaultFilterUtil {
  public static find(filters: DefaultFilter[] | undefined, key: DefaultFilterKey): DefaultFilter | undefined {
    if (!filters) return undefined;
    return filters.find((filter: DefaultFilter) => DefaultFilterUtil.matches(filter, key));
  }

  public static indexOf(filters: DefaultFilter[] | undefined, key: DefaultFilterKey): number {
    if (!filters) return -1;
    return filters.findIndex((filter: DefaultFilter) => DefaultFilterUtil.matches(filter, key));
  }

  private static matches(filter: DefaultFilter, key: DefaultFilterKey): boolean {
    if (filter.component !== key.component) return false;
    if (filter.id !== key.id) return false;
    return filter.riskType === key.riskType;
  }
}

export default DefaultFilterUtil;
